import { useState, useEffect, useMemo } from 'react';
import { transmissaoRepository } from '../../data/transmissaoRepository';
import { resolverVideoIdTransmissao } from '../../domain/usecases/resolverVideoIdTransmissao';
import type { TransmissaoFonte } from '@/shared/types';

interface UseTransmissaoLiveParams {
  telaId:                      string | null | undefined;
  transmissaoFonteId:          string | null;
  transmissaoVideoIdOverride:  string | null;
}

/**
 * Carrega a fonte de transmissão selecionada e resolve o video_id efetivo
 * (override da tela > ID cadastrado no roster).
 */
export function useTransmissaoLive({
  telaId,
  transmissaoFonteId,
  transmissaoVideoIdOverride,
}: UseTransmissaoLiveParams) {
  const [fonte, setFonte] = useState<TransmissaoFonte | null>(null);

  useEffect(() => {
    if (!telaId || !transmissaoFonteId) {
      setFonte(null);
      return;
    }
    let cancelado = false;
    transmissaoRepository.buscarParaTela(telaId, transmissaoFonteId)
      .then(data => { if (!cancelado) setFonte(data); })
      .catch(() => { if (!cancelado) setFonte(null); });
    return () => { cancelado = true; };
  }, [telaId, transmissaoFonteId]);

  const videoId = useMemo(
    () => resolverVideoIdTransmissao(transmissaoVideoIdOverride, fonte),
    [transmissaoVideoIdOverride, fonte],
  );

  const titulo = fonte?.nome ?? 'Transmissão ao vivo';

  return { fonte, videoId, titulo };
}
